import apiFetch from '../apiFetch'

export default function (token, uoId) {
  return apiFetch({ endPoint: `organizedUnit/UserAndDossierUo/${uoId}`, method: 'GET', body: null, token: token })
}
